import {DataService} from 'shared/services/data.service';
import {CockpitCard} from 'shared/dtos/cockpit-card';
import {MessageService} from 'shared/services/message.service';

export abstract class CockpitBaseService {
  protected abstract cardsData: CockpitCard[];

  constructor(
    private readonly dataService: DataService,
    private readonly messageService: MessageService
  ) {}

  public async selectAndActivateCard() {
    const cards = await this.getCockpitCardData();
    if (cards) {
      let card = cards.find(c => c.isSelected);

      if (!card) {
        if (await this.dataService.getIsForModule2()) {
          card = this.cardsData[1];
        } else {
          card = this.cardsData[0];
        }
      }
      this.messageService.getSendChartDialog(card);
    } else {
      this.messageService.getSendChartDialog(null);
    }
  }

  public resetSelection() {
    this.cardsData.forEach(c => (c.isSelected = false));
    this.cardsData[0].isSelected = true;
  }

  public async getCockpitCardData(): Promise<CockpitCard[]> {
    let moduleNumber = 0;
    if (await this.dataService.getIsForModule2()) {
      moduleNumber = 2;
    } else {
      moduleNumber = 1;
    }
    return this.cardsData
      .filter(
        card =>
          !card.module || card.module === 0 || card.module === moduleNumber
      )
      .sort((a, b) => a.position - b.position);
  }
}
